import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取责任方理赔列表
export const getClaimList = params => {
  return axios.request({
    url: "/finance/DutyClaim",
    method: "get",
    params
  });
};

// 新增理赔单
export const addClaim = data => {
  return axios.request({
    url: "/finance/DutyClaim",
    method: "post",
    data
  });
};

// 编辑理赔单
export const editClaim = data => {
  return axios.request({
    url: "/finance/DutyClaim/" + data.id,
    method: "put",
    data
  });
};

// 取消理赔单
export const cancelClaim = data => {
  return axios.request({
    url: "/finance/claim/cancel/" + data.id,
    method: "post"
  });
};

// 删除理赔单
export const deleteClaim = id => {
  return axios.request({
    url: "/finance/DutyClaim/" + id,
    method: "DELETE"
  });
};
// 获取理赔配置
export const getClaimConfig = () => {
  return axios.request({
    url: "/finance/DutyClaim/Conf",
    method: "get"
  });
};

// 理赔打印
export const printClaim = id => {
  return axios.request({
    url: `/finance/claim/pdf/${id}`,
    method: "get"
  });
};

// 获取责任方
export const getClaimDuty = params => {
  return axios.request({
    url: `/finance/DutyClaim/duty`,
    method: "get",
    params
  });
};

// 上传举证文件
export const uploadFile = data => {
  return axios.request({
    url: `/finance/DutyClaim/upload`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data
  });
};

// 删除举证文件
export const deleteFile = data => {
  return axios.request({
    url: `/finance/DutyClaim/delExtend/${data.id}`,
    method: "post",
    data
  });
};

// 财务操作
export const financeOperation = data => {
  return axios.request({
    url: `/finance/DutyClaim/finance/${data.id}`,
    method: "post",
    data
  });
};

// 获取订单类型
export const getOrderType = params => {
  return axios.request({
    url: `/finance/DutyClaim/orderType`,
    method: "get",
    params
  });
};

// 获取具体责任方
export const getDuty = params => {
  return axios.request({
    url: `/finance/DutyClaim/selectDuty/${params}`,
    method: "get"
  });
};

export const financeLog = params => {
  return axios.request({
    url: `/finance/DutyClaim/financeLog/${params}`,
    method: "get"
  });
};

export const DutyClaim = params => {
  return axios.request({
    url: `/finance/DutyClaim/${params}`,
    method: "get"
  });
};

